import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

const FADE_IN_GROUPS = [
  {
    selector: ".js-fade-in",
    from: { y: 30 },
    start: "top 90%",
    ease: "power4.out",
  },
  {
    selector: ".js-fade-in-left",
    from: { x: -30 },
    start: "top 80%",
    ease: "power1.out",
  },
  {
    selector: ".js-fade-in-right",
    from: { x: 30 },
    start: "top 70%",
    ease: "power1.out",
  },
];

function setupFadeIn(elements, fromVars, start, ease) {
  elements.forEach((element) => {
    ScrollTrigger.create({
      trigger: element,
      start,
      once: true,
      onEnter: () => {
        gsap.fromTo(
          element,
          { autoAlpha: 0, ...fromVars },
          {
            autoAlpha: 1,
            x: 0,
            y: 0,
            duration: 1,
            ease,
          }
        );
      },
    });
  });
}

export function animation() {
  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  if (prefersReducedMotion) return;

  const init = () => {
    FADE_IN_GROUPS.forEach(({ selector, from, start, ease }) => {
      const elements = document.querySelectorAll(selector);
      if (!elements.length) return;

      setupFadeIn(elements, from, start, ease);
    });

    const fadeInDelayElements = document.querySelectorAll(".js-fade-in-delay");
    fadeInDelayElements.forEach((element, index) => {
      ScrollTrigger.create({
        trigger: element,
        start: "top 80%",
        once: true,
        onEnter: () => {
          gsap.fromTo(
            element,
            { autoAlpha: 0, y: 30 },
            {
              autoAlpha: 1,
              y: 0,
              duration: 1,
              delay: index * 0.3,
              ease: "power1.out",
            }
          );
        },
      });
    });

    ScrollTrigger.refresh();
  };

  if (document.readyState === "complete") {
    init();
  } else {
    window.addEventListener("load", init, { once: true });
  }
}
